<template>
  {{ info }}
</template>

<script>
import { useCartStore } from '../pinia/CartStore'
import { mapState, mapActions } from 'pinia'
import { productPrice } from '../helpers/product'

export default {
  props: {
    request: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState (useCartStore, [
      'cart',
      'itemCount',
      'totalPrice',
    ]),
    total () {
      return productPrice(this.totalPrice)
    },
    info () {
      return this.cart.loading ? this.default : this[this.request]
    }
  }
}
</script>
